import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetBoxComponent } from '../../widgets/box/box.component';
import { WidgetOptionComponent } from '../../widgets/option/option.component';
import { ModalHelper } from '../../helpers/modal.helper';
import { WalletHelper } from '../../helpers/wallet.helper';

@Component({
  selector: 'app-connect',
  templateUrl: './connect.component.html',
  imports: [
    CommonModule,
    WidgetBoxComponent,
    WidgetOptionComponent,
  ]
})
export class AppConnectComponent {

  /**
   * Modal helper
   */
  modal_helper = inject(ModalHelper);

  /**
   * Wallet helper
   */
  wallet_helper = inject(WalletHelper);

  /**
   * List of wallets
   */
  wallets = signal(this.wallet_helper.listWallets());

  /**
   * Select wallet
   * 
   * @param wallet
   */
  async selectWallet(wallet: string) {
    await this.wallet_helper.connect(wallet);
    this.modal_helper.close();
  }
}
